<div class="chat-layout">
  <button
    class="hamburger-btn"
    (click)="toggleMobileMenu()"
    [class.active]="isMobileMenuOpen">
    <span class="hamburger-line"></span>
    <span class="hamburger-line"></span>
    <span class="hamburger-line"></span>
  </button>

  <div class="sidebar-container"
       [class.collapsed]="isSidebarCollapsed"
       [class.mobile-open]="isMobileMenuOpen">
         <app-sidebar
            [isCollapsed]="isSidebarCollapsed"
            [isCollectionsSelected]="showCollections"
            [isFeedbackSelected]="showFeedbackAdmin"
            [isMailboxSelected]="showMailbox"
            [isVisualizationsSelected]="showVisualizations"
            [isInferencesSelected]="showInferences"
            [isClustersSelected]="showClusters"
            [isLeaveSelected]="showLeave"
            [isAgentHooksSelected]="showAgentHooks"
            [canViewAgentHooks]="canViewAgentHooks"
            [canViewCollections]="canViewCollections"
            [canViewFeedback]="canViewFeedback"
            [canViewMailbox]="canViewMailbox"
            [canViewVisualizations]="canViewVisualizations"
            [canViewInferences]="canViewInferences"
            (toggleSidebar)="toggleSidebar()"
            (collectionsClicked)="onCollectionsClicked()"
            (feedbackClicked)="onFeedbackClicked()"
            (mailboxClicked)="onMailboxClicked()"
            (visualizationsClicked)="onVisualizationsClicked()"
            (inferencesClicked)="onInferencesClicked()"
            (clustersClicked)="onClustersClicked()"
            (leaveClicked)="onLeaveClicked()"
            (agentHooksClicked)="onAgentHooksClicked()"
            (promptsClicked)="onPromptsClicked()"
            (newChatClicked)="onNewChatClicked()"
            (chatHistoryItemClicked)="onChatHistoryItemClicked($event)"
            (chatDeleted)="onChatDeleted($event)"
            >
         </app-sidebar>
  </div>

  <div class="mobile-overlay"
       *ngIf="isMobileMenuOpen"
       (click)="closeMobileMenu()">
  </div>

  <div class="main-content" [class.sidebar-collapsed]="isSidebarCollapsed">
    <app-chat-area 
      [showCollections]="showCollections"
      [showFeedbackAdmin]="showFeedbackAdmin"
      [showMailbox]="showMailbox"
      [showVisualizations]="showVisualizations"
      [showInferences]="showInferences"
      [showClusters]="showClusters"
      [showLeave]="showLeave"
      [showAgentHooks]="showAgentHooks"
      [isSidebarCollapsed]="isSidebarCollapsed"
      (backToChat)="onBackToChat()"
      (chatSaved)="onChatSaved($event)"
      (inferencesGenerated)="onInferencesClicked()">
    </app-chat-area>
  </div>
</div>
